/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import './../styles/style.scss';

import { $, $$ } from './lib'
import inView from 'in-view';
import { Notyf } from 'notyf';

// Base notification styles
let notyf = new Notyf({
    duration: 4000,
    dismissible: true,
    icon: false
});


/*------------------------------------------------------------------
Import external
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {

    /*------------------------------------------------------------------
    Animate elements when they come in to view 
    ------------------------------------------------------------------*/

    inView('.js-in-view')
        .on('enter', el => { el.classList.add('inView') })

    let resourceFilters = $$('.js-resource-filter');

    if (resourceFilters) {
        resourceFilters.forEach(filterTrigger => {
            filterTrigger.addEventListener('click', (e) => {
                console.log('fds')

                e.preventDefault();

                let value = e.currentTarget.dataset.filter;
                let resourceCards = $$('.js-resource-item');

                resourceFilters.forEach(filter => {
                    filter.classList.remove('active');
                });

                e.currentTarget.classList.add('active');

                if (value === 'all') {
                    resourceCards.forEach(card => {
                        card.classList.remove('hidden');
                    })
                } else {

                    resourceCards.forEach(card => {
                        let cardTags = card.dataset.filter;
                        if (cardTags.includes(value)) {
                            card.classList.remove('hidden');
                        } else {
                            card.classList.add('hidden');
                        }
                    })
                }

            });
        });

    }

    /*------------------------------------------------------------------
    Post Load classname removal
    ------------------------------------------------------------------*/

    $$('.js-postload').forEach(element => {
        element.classList.remove('js-postload');
    });


    /*------------------------------------------------------------------
    Sticky header  
    ------------------------------------------------------------------*/

    let previousScrollPosition = 0;
    let scrollDelta = 5;
    let header = $('.header');
    let headerHeight = (header) ? header.clientHeight / 3 : 0;

    const stickyHeader = () => {
        let st = window.scrollY;
        if (Math.abs(previousScrollPosition - st) <= scrollDelta) return;
        if (st === 0) {
            header.classList.remove('nav-down');
            header.classList.remove('nav-up');
        } else if (st > previousScrollPosition && st > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        } else {
            if (st + window.innerHeight < document.body.clientHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }
        previousScrollPosition = st;
    }

    window.addEventListener('scroll', stickyHeader);


    /*------------------------------------------------------------------
    Subscription form
    ------------------------------------------------------------------*/

    let userform = $('form.userform');
    if (userform) {

        userform.addEventListener('submit', (event) => {
            event.preventDefault();

            fetch(userform.getAttribute('action'), {
                method: 'POST',
                body: new FormData(userform),
            })
                .then((response) => response.json())
                .then((data) => {

                    // Show a success message
                    notyf.success({ message: data.message, icon: false });

                    // Reset the form
                    userform.reset();
                })
                .catch((data) => {
                    console.log(data)
                });

        });
    }


});
